import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Waypoint } from 'react-waypoint'
import { useWindowSize } from 'usehooks-ts'

declare global {
  interface Window {
    chapters: any
  }
}

window.chapters = window.chapters || {}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    id: 'id',
    order: '0',
    long: 'Eine furchteinflössende Prophezeiung',
    subtitle: undefined,
    short: 'Kapitel 1',
    noMargin: 'false',
    source: 'Foto: Bla Blabla',
  }
  const ref = useRef<HTMLDivElement>(null)
  const id = properties?.id || 'missingID'
  const order = +(properties?.order || '0')
  const long = properties?.long
  const short = properties?.short
  const subtitle = properties?.subtitle
  const noMargin = properties?.noMargin === 'true'
  const [screenHeight, setScreenHeight] = useState<number>()
  const { width, height } = useWindowSize()
  useEffect(() => {
    setScreenHeight(height * 0.7)
  }, [width])

  useEffect(() => {
    if (!ref.current) return
    window.chapters[id] = { el: ref.current, title: long, id, order, short }
    const newChapterEvent = new CustomEvent('chapteradded')
    window.dispatchEvent(newChapterEvent)
  }, [ref.current])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <div ref={ref} />

      <TextWidth>
        <Waypoint
          scrollableAncestor={window}
          onEnter={() => {
            const newChapterEvent = new CustomEvent('chapteronscreen', {
              detail: id,
            })
            window.dispatchEvent(newChapterEvent)
          }}
        >
          <Wrapper id={id} className='Wrapper' noMargin={noMargin}>
            <ContentWrapper>
              {long && <Long colorMode={colorMode}>{long}</Long>}
              {subtitle && <Subtitle>{subtitle}</Subtitle>}{' '}
            </ContentWrapper>
          </Wrapper>
        </Waypoint>
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  overflow-x: hidden;
`

const ContentWrapper = styled.div`
  display: inline-block;
  width: 100%;
`

const Wrapper = styled.div<{ noMargin?: boolean }>`
  width: 100%;

  font-family: var(--font-serif);
  text-align: center;

  margin-top: ${({ noMargin }) => (noMargin ? '0' : '40px')};
  margin-bottom: 30px;
  padding-top: 15px;
`

const Long = styled.h2<{ colorMode: 'light' | 'dark' | undefined }>`
  font-family: var(--font-source);
  font-size: 36px;
  line-height: 1.15em;
  letter-spacing: 1px;
  margin-bottom: 20px;
  @media only screen and (max-width: 800px) {
    font-size: 26px;
  }
`

const Subtitle = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  letter-spacing: 0.4px;
  line-height: 1.3em;
  color: var(--text-color);
`

export default MainComponent
